import {RestService} from "@/services/rest/RestService";
import {CategoryAPIApi} from "@/api/pharma-pim-category";
import {CodeDescriptionRestDto} from "@/api/pharma-pim-category/models";
import {CustomerContext} from "@/context/CustomerContext";
import {AxiosResponse} from "axios";
import {ProductCategoryOverviewRestDto} from "@/api/pharma-cpc-product/models";
import {CacheService} from "@/services/cache/CacheService";
import {CacheKeyEnum} from "@/services/cache/CacheKeyEnum";

export class PimCategoryRestService extends RestService {

    private apiService: CategoryAPIApi;

    protected constructor() {
        super();

        this.apiService = new CategoryAPIApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().pimUrl);
    }

    public async findInternalProductCategories(search_name?: string | null): Promise<CodeDescriptionRestDto[]> {
        let promise: Promise<AxiosResponse<CodeDescriptionRestDto[]>> =
            CacheService.getInstance().get(CacheKeyEnum.INTERNAL_PRODUCT_CATEGORIES);

        if (promise !== null) {
            const result: AxiosResponse<CodeDescriptionRestDto[]> = await promise;
            return result.data;
        }

        promise = this.apiService.findInternalProductCategories(undefined, undefined, search_name);
        CacheService.getInstance().set(CacheKeyEnum.INTERNAL_PRODUCT_CATEGORIES, promise);

        const result: AxiosResponse<CodeDescriptionRestDto[]> = await promise;
        return result.data;


    }
}
